var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 19.5,
    x: 0.75,
    y: 0.25,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    rx: 1.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 29,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 19.5,
    x: 0.75,
    y: 0.25,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D72238",
    d: "M.5 20h28v-6.666H.5v6.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169A53",
    d: "M.5 6.667h28V0H.5v6.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m.5 0 9.333 6.667v6.666L.5 20V0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKw);
export default __webpack_public_path__ + "static/media/kw.b6a321299c525124df064496bc6f768d.svg";
export { ForwardRef as ReactComponent };